import { render, staticRenderFns } from "./SustainabilityView.vue?vue&type=template&id=384ffdbe"
import script from "./SustainabilityView.vue?vue&type=script&lang=js"
export * from "./SustainabilityView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports